var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "linha" },
    [
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Estretégia ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "1", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Participação Carteira ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Emissor/Gestor ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Custodiante ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "1", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Liquidez em dias ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Vencimento ")])
          ])
        ]
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Saldo Bruto ")])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }